// extracted by mini-css-extract-plugin
export default {"background":"NotFound_background__t1URY"};